module.exports = __webpack_public_path__ + "img/1014217282.84760f2a.png";